import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  margin: 8px;
  max-width: 251px;
`;

const Title = styled.div`
  color: #000;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
`;

const Description = styled.div`
  color: #5f6368;
  font-size: 14px;
  line-height: 20px;
  margin-top: 8px;
`;

const Disclaimer = styled(Description)`
  color: black;
  font-weight: bold;
  font-style: italic;
  font-size: 11px;
`;

const Takeaway = props => {
  const { condition, type, amount, percent, isHedge } = props;

  return (
    <Wrapper>
      <Title>
        THE TAKEAWAY
      </Title>
      <Description>
        {condition}, <b>your {type} would be {amount}</b> ({percent} of your current loan balance).
      </Description>
      {isHedge &&
        <Disclaimer>
          *Prepayment Penalty includes swap breakage fee
        </Disclaimer>}
    </Wrapper>
  );
};

export default Takeaway;
